import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  fetchNotificationSyestemList,
  fetchUpdateSystemNotification,
} from "../actions/notification";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { Card, Col, Container, Row } from "react-bootstrap";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { useTranslation } from "react-i18next";
import InputField from "../components/Admin/Reusable/InputField";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";
import { Chip, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { toast } from "react-toastify";
import { fetchCountryFormList } from "../actions/country";
import { basicFormValidationHandler } from "../utils";
import { isEmpty } from "lodash";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const NotificationSystemAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const { notificationSystemDetail } = useSelector(
    (state) => state.notificationReducer
  );
  const { countryFormList } = useSelector((state) => state.countryReducer);

  //breadcrumb
  const translateForm = "notificationsForm";
  const translateModule = "notificationsSystem";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const handleCopyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(text)
        .then(() =>
          toast.success(t("global.copy_clipboard"), {
            theme: "colored",
          })
        )
        .catch(() =>
          toast.error(t("global.copy_clipboard_error"), {
            theme: "colored",
          })
        );
    } else {
      // fallback za nesigurne kontekste
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // izbegni scroll
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand("copy");
        toast.success(t("global.copy_clipboard"));
      } catch (err) {
        toast.error(t("global.copy_clipboard_error"));
      }

      document.body.removeChild(textarea);
    }
  };

  // const handleCopyToClipboard = (text) => {
  //   if (!navigator.clipboard) {
  //     toast.error(t("global.copy_clipboard_error"), { theme: "colored" });
  //     console.warn("Clipboard API nije dostupan");
  //     return;
  //   }

  //   navigator.clipboard
  //     .writeText(text)
  //     .then(() => {
  //       toast.success(t("global.copy_clipboard"), { theme: "colored" });
  //     })
  //     .catch((error) => {
  //       toast.error(t("global.copy_clipboard_error"), { theme: "colored" });
  //       console.error("Greška pri kopiranju u clipboard:", error);
  //     });
  // };

  useEffect(() => {
    dispatch(fetchNotificationSyestemList(id));
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  const initialState = {
    title: "",
    name: "",
    body: "",
    bodyApp: "",
    countryId: "",
    metadata: [],
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const clientValidationHandler = () => {
    const { title, body } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      title,
      body,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  useEffect(() => {
    if (notificationSystemDetail) {
      setData({
        ...data,
        title: notificationSystemDetail.title || "",
        name: notificationSystemDetail.name || "",
        body: notificationSystemDetail.body || "",
        bodyApp: notificationSystemDetail.bodyApp || "",
        countryId: notificationSystemDetail.countryId || "",
        metadata: notificationSystemDetail.metadata || [],
      });
    }
  }, [notificationSystemDetail, dispatch]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }
    data.id = id;
    dispatch(fetchUpdateSystemNotification(data, navigate));
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={notificationSystemDetail && notificationSystemDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="notification-holder-admin-left-side-text">
                            <Row>
                              <Col lg={4} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  disabled
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("global.drzava")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.countryId}
                                    label={t("global.drzava")}
                                    name="countryId"
                                    size="small"
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Col>
                              <Col lg={8} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("global.notification_name")}
                                  name="name"
                                  value={data?.name}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                  multiline
                                />
                              </Col>
                              <Col lg={12} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("global.notification_title")}
                                  name="title"
                                  value={data?.title}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  onChange={handleInputChange}
                                  size="small"
                                  required
                                  multiline
                                />
                              </Col>
                              {data?.metadata?.length > 0 && (
                                <div className="metadata-holder mb-3">
                                  <h6 id="demo-simple-select-label">
                                    {t("global.meta_data")}
                                  </h6>
                                  <div className="tag-items-mail-body">
                                    {data?.metadata?.map((item, index) => (
                                      <div
                                        className="tag-main-body-item"
                                        key={index}
                                      >
                                        <Chip
                                          variant="outlined"
                                          label={
                                            item?.description +
                                            " -> %" +
                                            item?.name +
                                            ""
                                          }
                                          onClick={() =>
                                            handleCopyToClipboard(
                                              `%${item?.name}`
                                            )
                                          }
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              <Col lg={12} md={12} xs={12} className="mb-4">
                                <h6 id="demo-simple-select-label">
                                  {t("global.mail_notification")} *
                                </h6>
                                <CKEditor
                                  name="body"
                                  editor={Editor}
                                  data={data.body}
                                  onReady={(editor) => {}}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setData((prevUser) => ({
                                      ...prevUser,
                                      body: data,
                                    }));
                                  }}
                                />
                              </Col>
                              <Col lg={12} md={12} xs={12} className="mb-4">
                                <h6 id="demo-simple-select-label"></h6>
                                <InputField
                                  label={t("global.notification_mob")}
                                  name="bodyApp"
                                  value={data?.bodyApp}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  onChange={handleInputChange}
                                  size="small"
                                  multiline
                                  minRows={3}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default NotificationSystemAdd;
